import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getThemeClassNames } from 'themes';

import { MirrorService } from 'services/MirrorService';
import { AppDomain } from 'types/enums/AppDomain';

import { isComplianceStatementEnabledSelector } from 'store/common/selectors';

import { BaseButton, ButtonTypes } from 'components/base/BaseButton';
import { Logo } from 'components/shared/Logo';

import { SidebarMenu } from './submodules/HeaderMenu';
import { UpgradeControls } from './submodules/UpgradeControls';

import styles from './header.module.sass';

type PropTypes = {
  isDisabled?: boolean;
};

export const Header: React.FC<PropTypes> = ({ isDisabled }) => {
  const { t } = useTranslation(['app', 'common']);

  const isComplianceStatementEnabled = useSelector(
    isComplianceStatementEnabledSelector
  );

  const rootClassName = getThemeClassNames(styles.wrapper, {
    [AppDomain.MePlusYou]: styles.primary,
    [AppDomain.LocalsDate]: styles.localsDateTheme,
    [AppDomain.SweatHeartSoul]: styles.primary,
  });

  const getLightLogoBySiteId =
    !MirrorService.isYourLove4Life &&
    !MirrorService.isRelationshipNest &&
    !MirrorService.isCupidKeys &&
    !MirrorService.isAmourPulse &&
    !MirrorService.isMyConnectly &&
    !MirrorService.isTenderTalkers &&
    !MirrorService.isHookupers &&
    !MirrorService.isDatesMe &&
    !MirrorService.isMePlusYou &&
    !MirrorService.isLocalsJoy &&
    !MirrorService.isBestHookuper &&
    !MirrorService.isHookupParadise &&
    !MirrorService.isUniteus &&
    !MirrorService.isMeamo &&
    !MirrorService.isPpl2ppl &&
    !MirrorService.isFinderSingles &&
    !MirrorService.isJoyFinder &&
    !MirrorService.isFlirtGuru &&
    !MirrorService.isFlirtDiscovery &&
    !MirrorService.isAdventureRelation &&
    !MirrorService.isDreamsDate &&
    !MirrorService.isSociableSpots &&
    !MirrorService.isMeetNests &&
    !MirrorService.isPeopleMeetClub &&
    !MirrorService.isGotLinkedNow &&
    !MirrorService.isMeetHarbor &&
    !MirrorService.isRelationTunes &&
    !MirrorService.isDateMateHub &&
    !MirrorService.isLinkupNook &&
    !MirrorService.isTheLinkupers &&
    !MirrorService.isSoulMatesLab &&
    !MirrorService.isFairyDates &&
    !MirrorService.isWaitForMe &&
    !MirrorService.isLookFor4you &&
    !MirrorService.isTheManWoman &&
    !MirrorService.isUsTogether &&
    !MirrorService.isAmorPassion &&
    !MirrorService.isAmoreAffair &&
    !MirrorService.isAmoreLover &&
    !MirrorService.isAmorFlames &&
    !MirrorService.isAmoreDesire &&
    !MirrorService.isJustLovebirds &&
    !MirrorService.isAdventureDate;

  return (
    <>
      <header className={rootClassName}>
        {MirrorService.isSweatHeartSoul && (
          <div className={styles.subheader}>
            <Link to="/terms" className={styles.policyLink}>
              {t('app:termsOfUse')}
            </Link>
            <Link to="/refund-policy" className={styles.policyLink}>
              {t('common:refundPolicy')}
            </Link>
            <Link to="/privacy-policy" className={styles.policyLink}>
              {t('common:privacyPolicy')}
            </Link>
            <Link to="/tracking-policy" className={styles.policyLink}>
              {t('common:trackingpolicy')}
            </Link>
          </div>
        )}
        <div className={styles.container}>
          <div className={styles.logoWrap}>
            <BaseButton
              type={ButtonTypes.Transparent}
              ariaLabel="home"
              to="/finder"
              disabled={isDisabled}
            >
              <Logo hideBottomLine dark={getLightLogoBySiteId} />
            </BaseButton>
          </div>

          <div className={styles.menuWrap}>
            <SidebarMenu className={styles.sidebarMenu} disabled={isDisabled} />

            <UpgradeControls />
          </div>
        </div>
      </header>
      {MirrorService.isSweatHeartSoul && isComplianceStatementEnabled && (
        <div className={styles.complianceStatement}>
          <Link to="/compliance-statement" className={styles.policyLink}>
            {t('common:complianceStatement')}
          </Link>
        </div>
      )}
    </>
  );
};
